import { ActionType, ResetAllActionType } from "./RootAction";
import { assessmentInfoReducer, AssessmentInfoState } from "./usecase/assessment/info/reducer";
import { assessmentScheduleReducer, AssessmentScheduleState } from "./usecase/assessment/schedule/reducer";
import { informationReducer, InformationState } from "./usecase/information/reducer";
import { authReducer, AuthState } from "./usecase/auth/reducer";
import { adminCareCommentReducer, AdminCareCommentState } from "./usecase/admin/care_comment/reducer";
import { careCommentReducer, CareCommentState } from "./usecase/care_comment/reducer";
import { careRecipientReducer, CareRecipientState } from "./usecase/care_recipient/reducer";
import { detectionReducer, DetectionState } from "./usecase/detection/reducer";
import { detectionConfigReducer, DetectionConfigState } from "./usecase/detection_config/reducer";
import { diseaseKnowledgeReducer, DiseaseKnowledgeState } from "./usecase/disease_knowledge/reducer";
import { reportReducer, ReportState } from "./usecase/report/reducer";
import { userReducer, UserState } from "./usecase/user/reducer";
import { adminCareRecipientReducer, AdminCareRecipientState } from "./usecase/admin/care_recipient/reducer";
import { adminServiceProviderReducer, AdminServiceProviderState } from "./usecase/admin/service_provider/reducer";
import { adminUserReducer, AdminUserState } from "./usecase/admin/user/reducer";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { adminListReducer, AdminListState } from "./usecase/admin/list/reducer";
import { faqReducer, FAQState } from "./usecase/faq/reducer";
import { adminLoginLogReducer, AdminLoginLogState } from "./usecase/admin/login_log/reducer";
import { adminCareCommentAnalysisReducer, AdminCareCommentAnalysisState } from "./usecase/admin/care_comment_analysis/reducer";
import { adminCareRecipientMemoReducer, AdminCareRecipientMemoState } from "./usecase/admin/care_recipient_memo/reducer";
import { AdminOperationLogState, adminOperationLogReducer } from "./usecase/admin/admin_operation_log/reducer";
import { utilizationDocumentReducer, UtilizationDocumentState } from "./usecase/utilization_document/reducer";
import { inquiryReducer, InquiryState } from "./usecase/inquiry/reducer";

export type RootState = Readonly<{
    assessmentInfo: AssessmentInfoState,
    assessmentSchedule: AssessmentScheduleState,
    auth: AuthState,
    adminCareComment: AdminCareCommentState
    careComment: CareCommentState,
    careRecipient: CareRecipientState,
    detection: DetectionState,
    detectionConfig: DetectionConfigState,
    diseaseKnowledge: DiseaseKnowledgeState,
    information: InformationState,
    faq: FAQState,
    report: ReportState,
    user: UserState,
    utilizationDocument: UtilizationDocumentState,
    inquiry: InquiryState,
    adminServiceProvider: AdminServiceProviderState,
    adminUser: AdminUserState,
    adminCareRecipient: AdminCareRecipientState,
    adminList: AdminListState,
    adminLoginLogList: AdminLoginLogState,
    adminCareCommentAnalysis: AdminCareCommentAnalysisState,
    adminCareRecipientMemo: AdminCareRecipientMemoState,
    adminOperationLog: AdminOperationLogState
}>;

const appReducer = combineReducers<RootState>({
    assessmentInfo: assessmentInfoReducer,
    assessmentSchedule: assessmentScheduleReducer,
    auth: authReducer,
    adminCareComment: adminCareCommentReducer,
    careComment: careCommentReducer,
    careRecipient: careRecipientReducer,
    detection: detectionReducer,
    detectionConfig: detectionConfigReducer,
    diseaseKnowledge: diseaseKnowledgeReducer,
    information: informationReducer,
    faq: faqReducer,
    report: reportReducer,
    user: userReducer,
    utilizationDocument: utilizationDocumentReducer,
    inquiry: inquiryReducer,
    adminServiceProvider: adminServiceProviderReducer,
    adminUser: adminUserReducer,
    adminCareRecipient: adminCareRecipientReducer,
    adminList: adminListReducer,
    adminLoginLogList: adminLoginLogReducer,
    adminCareCommentAnalysis: adminCareCommentAnalysisReducer,
    adminCareRecipientMemo: adminCareRecipientMemoReducer,
    adminOperationLog: adminOperationLogReducer
});


const rootReducer = (state: RootState | undefined, action: ResetAllActionType) => {
    if (action.type === `${ActionType.base}/${ActionType.reset}`) {
        state = undefined;
    }
    return appReducer(state, action);
};

// root state
export const Store = configureStore({
    reducer: rootReducer
});

export type State = ReturnType<typeof Store.getState>;

type AppDispatch = typeof Store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
